import { PAY_NOW_SUCCESS } from '../actions/checkout'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  isReady: false,
  reference: '',
  email: '',
  packageName: '',
}

const thankyouReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PAY_NOW_SUCCESS:
      return {
        ...state,
        isReady: true,
        reference: action.payload.reference,
        email: action.payload.email,
        packageName: action.payload.packageName,
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

export default thankyouReducer
